import React from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

export enum SortIconDirection {
  UP = 'up',
  DOWN = 'down',
  NONE = 'none',
}
export const SortIcon: React.FC<SortIconProps> = ({ size = 24, testID, direction = SortIconDirection.NONE }) => {
  const { colors } = useTheme()
  const upColor = direction === SortIconDirection.UP ? colors.iconActive : colors.iconDefault
  const downColor = direction === SortIconDirection.DOWN ? colors.iconActive : colors.iconDefault
  return (
    <Svg width={size} height={size} viewBox='0 0 24 24' testID={testID}>
      <Path
        fill={upColor}
        stroke={upColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M17.5 9L12 4L6.5 9L17.5 9Z'
      />
      <Path
        fill={downColor}
        stroke={downColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        d='M6.5 15L12 20C12 20 15.3521 16.9526 17.5 15H6.5Z'
      />
    </Svg>
  )
}

type SortIconProps = {
  size?: number
  testID?: string
  direction?: SortIconDirection
}
